import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const getItems = async (collection) => {
  const res = await axios.get(`${API_BASE_URL}/collections/${collection}`);
  const items = Array.isArray(res.data) ? res.data : [];
  return items;
};

export const saveItem = async (collection, item) => {
  const payload = {
    title: item.title || '',
    content: item.content || '',
    img: item.img || null
  };

  if (item.id) {
    await axios.put(`${API_BASE_URL}/collections/${collection}/${item.id}`, payload);
  } else {
    await axios.post(`${API_BASE_URL}/collections/${collection}`, payload);
  }

  const all = await getItems(collection);
  return all;
};

export const deleteItem = async (collection, id) => {
  if (!id) {
    const all = await getItems(collection);
    return all;
  }

  await axios.delete(`${API_BASE_URL}/collections/${collection}/${id}`);
  const all = await getItems(collection);
  return all;
};

export const clearCollection = async (collection) => {
  await axios.delete(`${API_BASE_URL}/collections/${collection}`);
  const all = await getItems(collection);
  return all;
};

export const saveItems = async (collection, items) => {
  // Check if items contain raw File objects (bulk upload)
  const hasFiles = items.some(item => item.file instanceof File);

  if (hasFiles) {
        const formData = new FormData();
        items.forEach(item => {
            if (item.file instanceof File) {
                formData.append('images', item.file);
            }
        });
        
        // Pass title if provided (for bulk, we might just pass one common title or handle differently)
        // Based on user request: "heading manual add karo tu aye nahi tu only image"
        // If items[0].title is present, send it.
        if (items.length > 0 && items[0].title) {
            formData.append('title', items[0].title);
        }

        try {
      const res = await axios.post(`${API_BASE_URL}/collections/${collection}/upload`, formData, {
        headers: {
          // Let axios set content-type with boundary
        }
      });
      // Return all items (fetch fresh list to be sure)
      return getItems(collection);
    } catch (err) {
      console.error("Bulk upload failed", err);
      throw err;
    }
  }

  // Fallback to legacy Base64 handling for individual items or text-only updates
  const promises = items.map(item => saveItem(collection, item));
  await Promise.all(promises);
  return getItems(collection);
};
